import { default as _Vue } from 'vue';
import { Store } from 'vuex';
import { AbstractService } from '@/plugins/podolib/lib/AbstractService';
import axios from 'axios';
import moment from 'moment';

// Service options type
export type Options = {
  cloudUrl: string;
};

// Store state type
export type State = {
  timeDrift: number;
};

enum Mutation {
  SET__TIME_DRIFT = 'SET__TIME_DRIFT',
}

/**
 * @author Damien CORLER <d.corler@zhortech.com>
 * @since 2.2.0
 * @version 1.0.0
 */
export default class CommonsService extends AbstractService<Options, State> {
  /**
   * @param options
   */
  constructor(options?: Options) {
    super(options, 'commons');
  }

  /**
   * Initialize plugin
   */
  async init(Vue: typeof _Vue, store: Store<any>) {
    await super.init(Vue, store);

    this.$register(this.defaultState, {
      mutations: {
        [Mutation.SET__TIME_DRIFT](state, timeDrift: number) {
          Vue.set(state, 'timeDrift', timeDrift);
        },
      },
    });

    try {
      await this.fetchTimeDrift();
    } catch (e) {
      // Ignore
      console.error(e);
    }
  }

  /**
   * Get default state of this store module
   */
  public get defaultState(): State {
    return {
      timeDrift: 0,
    };
  }

  /**
   * Fetch time drift
   */
  async fetchTimeDrift() {
    // Get current client date (before request)
    const clientDateBeforeRequest = new Date();

    // Fetch root endpoint
    const response = await axios.get(this.options.cloudUrl);

    // Get current client date (after request)
    const clientDateAfterRequest = new Date();

    // Get server date
    const serverDate = new Date(response.request.getResponseHeader('Date'));

    // Calculate difference between client and server dates
    const serverClientRequestDiffTime = serverDate.getTime() - clientDateBeforeRequest.getTime();

    // Calculate response time
    const serverClientResponseDiffTime = clientDateAfterRequest.getTime() - serverDate.getTime();

    const responseTime =
      (serverClientRequestDiffTime -
        clientDateAfterRequest.getTime() +
        clientDateBeforeRequest.getTime() -
        serverClientResponseDiffTime) /
      2;

    const serverTimeOffset = responseTime - serverClientResponseDiffTime;

    /*const date = new Date();

    date.setTime(date.getTime() + serverTimeOffset);*/

    /*console.log(serverDate);
    console.log(clientDateBeforeRequest);
    console.log(clientDateAfterRequest);
    console.log(serverClientRequestDiffTime);
    console.log(serverClientResponseDiffTime);
    console.log(serverClientResponseDiffTime - serverClientRequestDiffTime);
    console.log(responseTime);
    console.log(serverTimeOffset);*/

    /*const responseTime =
      (serverClientRequestDiffTime - clientDateAfterRequest + clientDateBeforeRequest - serverClientResponseDiffTime) /
      2;

    const serverTimeOffset = serverClientResponseDiffTime - responseTime;

    const date = new Date();

    date.setTime(date.getTime() + serverTimeOffset);

    console.log(serverTimeOffset);*/

    this.$commit(Mutation.SET__TIME_DRIFT, serverClientRequestDiffTime);

    this.logger.info(
      `Timer drift : ${Math.sign(serverClientRequestDiffTime) < 0 ? '-' : '+'}${moment(
        Math.abs(serverClientRequestDiffTime),
      ).format('mm:ss')}`,
    );
  }

  get timeDrift(): number {
    return this.$state('timeDrift');
  }
}
